module.exports = __webpack_public_path__ + "media/images/logo_bip-0fc7edc9b6ed594d202a63559e1d320b.jpg";